import { FormLabel as JoyFormLabel, FormLabelProps, Tooltip } from '@mui/joy';
import { Info } from '@phosphor-icons/react';

import { TooltipPosition } from 'theme/enums';

interface IProps extends FormLabelProps {
  tooltip?: string;
}

export const FormLabel = ({ children, tooltip, ...rest }: IProps) => {
  return (
    <JoyFormLabel {...rest}>
      {children}
      {tooltip && (
        <Tooltip placement={TooltipPosition.TOP} title={tooltip}>
          <Info />
        </Tooltip>
      )}
    </JoyFormLabel>
  );
};
